export function getDefaultActionReducer(state, action) {
	return {
		...state,
		error: null,
		isLoading: action.isLoading,
	};
}
